import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import logo from '../assets/logo.png';

function Navbar() {
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);

  const linkClass = ({ isActive }) =>
    isActive ? 'navbar__link navbar__link--active' : 'navbar__link';

  return (
    <header className="navbar">
      <div className="navbar__inner">
        <Link to="/" className="navbar__brand" onClick={close}>
          <img src={logo} alt="Ron Johanson for County Legislature" className="navbar__logo" />
          <span className="navbar__brand-text">
            Ron Johanson
            <small>Big Flats First &middot; 2nd District Legislator</small>
          </span>
        </Link>

        <button
          className="navbar__toggle"
          onClick={() => setOpen(o => !o)}
          aria-label="Toggle menu"
        >
          {open ? 'Close' : 'Menu'}
        </button>

        <nav className={`navbar__links ${open ? 'navbar__links--open' : ''}`}>
          <NavLink to="/about" className={linkClass} onClick={close}>About</NavLink>
          <NavLink to="/values" className={linkClass} onClick={close}>Values</NavLink>
          <NavLink to="/priorities" className={linkClass} onClick={close}>Priorities</NavLink>
          <NavLink to="/family" className={linkClass} onClick={close}>Family</NavLink>
          <NavLink to="/contact" onClick={close} className="navbar__cta">
            Get Involved
          </NavLink>
        </nav>
      </div>
    </header>
  );
}

export default Navbar;
